module.exports = __webpack_public_path__ + "static/media/parking.93c528a7.svg";